/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-template */

export const setDeviceTID = (deviceTID) => {
    sessionStorage.setItem('deviceTID', deviceTID);
};

export const registeredCallBackMethod = () => {
    if (window.hasOwnProperty('_bcn') && window._bcn.hasOwnProperty('dvc')) {
        setDeviceTID(window._bcn.dvc.getTID());
    }
};

export const getDeviceTID = () => {
    const deviceTID = sessionStorage.getItem('deviceTID');
    if (deviceTID === null) {
        return null;
    }
    return deviceTID;
};

export const sendDevicePayload = () => {
    const deviceTID = getDeviceTID();
    if ((deviceTID === null || deviceTID === '') && window?._bcn?.dvc) {
        window._bcn.dvc.submit(registeredCallBackMethod);
    } else {
        console.log('The following device transaction id was already sent to Accertify: ' + deviceTID);
    }
};

export const collectMetadata = () => {
    if (window.hasOwnProperty('_bcn')) {
        window._bcn.flush();
        const browserUUID = window.localStorage.getItem('browserUUID');
        const ubaId = window._bcn.getToken();
        const ubaSessionId = window._bcn.getUbaSessionId();
        const pageId = window._bcn.getPageId();
        const ubaEvents = window._bcn.getEvents();
        const metadata = {
            devTID: getDeviceTID(),
            sessionId: browserUUID,
            ubaSessionId,
            ubaId,
            pageId,
            ubaEvents,
        };
        return metadata;
    }
    return {};
};

export default {};
